var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoXml01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6478B9;}\n\t.st1{fill:#C1C6E5;}\n\t.st2{fill:#040405;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1266",
    className: "st0",
    d: "M27.9,34.9H8.1c-1.9,0-3.5-1.6-3.5-3.5V4.6c0-1.9,1.6-3.5,3.5-3.5h16.4l7,7v23.4 C31.4,33.4,29.9,34.9,27.9,34.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1267",
    className: "st1",
    d: "M4.6,25.6h26.9v5.8c0,1.9-1.6,3.5-3.5,3.5H8.1c-1.9,0-3.5-1.6-3.5-3.5L4.6,25.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1268",
    className: "st1",
    d: "M31.4,8.1h-3.5c-1.9,0-3.5-1.6-3.5-3.5l0,0V1.1L31.4,8.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1269",
    className: "st2",
    d: "M24.8,0.7c-0.1-0.1-0.3-0.2-0.4-0.2H8.1C5.8,0.5,4,2.3,4,4.6v26.9c0,2.3,1.8,4.1,4.1,4.1 h19.9c2.3,0,4.1-1.8,4.1-4.1V8.1c0-0.2-0.1-0.3-0.2-0.4L24.8,0.7z M25,2.5l5,5h-2.1c-1.6,0-2.9-1.3-2.9-2.9L25,2.5z M8.1,1.6h15.8 v2.9c0,2.3,1.8,4.1,4.1,4.1h2.9V25H5.2V4.6C5.2,3,6.5,1.7,8.1,1.6L8.1,1.6z M27.9,34.3H8.1c-1.6,0-2.9-1.3-2.9-2.9v-5.3h25.7v5.3 C30.8,33,29.5,34.3,27.9,34.3L27.9,34.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1270",
    className: "st2",
    d: "M24.4,32h-1.8v-4.1c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v4.7c0,0.3,0.3,0.6,0.6,0.6l0,0 h2.3c0.3,0,0.6-0.3,0.6-0.6S24.7,32,24.4,32L24.4,32L24.4,32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1271",
    className: "st2",
    d: "M14.2,27.4c-0.3-0.1-0.6,0-0.8,0.3c0,0,0,0,0,0L12.7,29l-0.6-1.3c-0.1-0.3-0.5-0.4-0.8-0.3 c-0.3,0.1-0.4,0.5-0.3,0.8l0,0l0,0l1,2.1l-1,2.1c-0.1,0.3,0,0.6,0.3,0.8c0.3,0.1,0.6,0,0.8-0.3l0,0l0,0l0.6-1.3l0.6,1.3 c0.1,0.3,0.5,0.4,0.8,0.3c0.3-0.1,0.4-0.5,0.3-0.8l0,0l-1-2.1l1-2.1C14.6,27.9,14.5,27.6,14.2,27.4C14.2,27.4,14.2,27.4,14.2,27.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1272",
    className: "st2",
    d: "M19.9,27.4c-0.3-0.1-0.5,0.1-0.7,0.3L18,30.5l-1.2-2.8c-0.1-0.3-0.5-0.4-0.8-0.3 c-0.2,0.1-0.4,0.3-0.4,0.5v4.7c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6v-1.8l0.6,1.5c0.1,0.3,0.5,0.4,0.8,0.3 c0.1-0.1,0.2-0.2,0.3-0.3l0.6-1.5v1.8c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6v-4.7C20.3,27.7,20.1,27.4,19.9,27.4L19.9,27.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1273",
    className: "st2",
    d: "M12.9,19c0.2,0.2,0.6,0.2,0.8,0c0.2-0.2,0.2-0.6,0-0.8l0,0l-3.1-3.1l3.1-3.1 c0.2-0.2,0.2-0.6,0-0.8c-0.2-0.2-0.6-0.2-0.8,0l-3.5,3.5c-0.2,0.2-0.2,0.6,0,0.8l0,0L12.9,19z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1274",
    className: "st2",
    d: "M22.3,19c0.2,0.2,0.6,0.2,0.8,0l0,0l3.5-3.5c0.2-0.2,0.2-0.6,0-0.8l0,0l-3.5-3.5 c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8l0,0l3.1,3.1l-3.1,3.1C22,18.4,22,18.8,22.3,19C22.3,19,22.3,19,22.3,19z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_45",
    cx: 18.1,
    cy: 15.1,
    rx: 0.6,
    ry: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_46",
    cx: 20.3,
    cy: 15.1,
    rx: 0.6,
    ry: 0.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_47",
    cx: 15.6,
    cy: 15.1,
    rx: 0.6,
    ry: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoXml01);
export default __webpack_public_path__ + "static/media/ico-xml-01.9b8be75d640561a4005baa228275c2b3.svg";
export { ForwardRef as ReactComponent };